// This is the only realistic key for slots and is recommended in the docs
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { OTPInput } from 'input-otp';
import classnames from 'classnames';
import { useController, useFormContext } from 'react-hook-form';
import { Slot } from './Slot';
import styles from './styles.module.scss';

/**
 * A component for entering OTP (One Time Password) codes.
 * @param {object} props - Component props.
 * @param {string} props.name - name attribute for the input field
 * @param {string} [props.dataTestId] - data-testid attribute for testing
 * @param {boolean} [props.isRequired] - whether the field is required
 * @param {string} [props.placeholder] - placeholder text for the input field
 * @param {string} [props.pushPasswordManagerStrategy] - strategy for detecting Password Managers in the page and then shifting their badges to the right side (enabled by default)
 * @returns {JSX.Element} The rendered input element
 */
export function OtpInput({
  name,
  dataTestId = '',
  isRequired = false,
  ...inputProps
}) {
  const {
    control,
  } = useFormContext();

  const controllerSettings = {
    name,
    control,
    rules: { required: isRequired },
  };

  const {
    field,
    fieldState: { error },
  } = useController(controllerSettings);

  return (
    <div className={styles.otpInputContainer}>
      <OTPInput
        containerClassName={String(styles.group)}
        render={({ slots }) => (
          <>
            <div
              className={classnames(styles.flex, {
                [styles.hasError ?? '']: !!error,
              })}
            >
              {slots.map((slot, idx) => (
                <Slot key={idx} {...slot} />
              ))}
            </div>
          </>
        )}
        maxLength={6}
        name={name}
        data-testid={dataTestId}
        aria-invalid={!!error}
        {...inputProps}
        {...field}
      />
    </div>
  );
}
